import { createMixin } from '.';

const useTimeout = (controller) => {
  const timeoutIds = new Set();

  /**
   * @param {Number} delay
   * @param {Function} callback
   * @return {Number} timeout ID
   */
  const timeout = (delay, callback) => {
    const timeoutId = setTimeout(() => {
      timeoutIds.delete(timeoutId);
      callback.call(controller);
    }, delay);
    timeoutIds.add(timeoutId);
    return timeoutId;
  };
  /** @type {timeout} */
  controller.timeout = timeout;

  /**
   * @param {Number} id
   * @return {void}
   */
  const clearTimeout = (id) => {
    timeoutIds.delete(id) && window.clearTimeout(id);
  };
  /** @type {clearTimeout} */
  controller.clearTimeout = clearTimeout;

  const disconnect = () => {
    if (timeoutIds.size) {
      timeoutIds.forEach(window.clearTimeout);
      timeoutIds.clear();
    }
  };
  return disconnect;
};

/**
 * Adds timeouts to your controllers with automatic clearing on disconnect
 * @example Usage
 *   class MyController extends Controller {
 *     connect() {
 *       useTimeout(this)
 *     }
 *
 *     send() {
 *       this.sendTimeout = this.timeout(2000, () => doSomething())
 *     }
 *
 *     discard() {
 *       this.sendTimeout && this.clearTimeout(this.sendTimeout)
 *     }
 *   }
 *
 * @param {Object} controller
 * @return {void}
 */
export default createMixin(useTimeout);
